






































import axios from 'axios'
import Message, { IMessage } from '@/models/Message'
import { apiV1AdminMessagesPath } from '@/rails/routes'
import { Component } from 'vue-property-decorator'
import { DataTableHeader } from 'vuetify'
import PageBase, {BreadCrumb} from '@/pages/page-base'
import ListCount from '@/components/admin/ListCount.vue'

@Component({
  components: {
    ListCount
  }
})
export default class MessageIndex extends PageBase {
  headers: Array<DataTableHeader> = [
    { text: '', value: 'actions', sortable: false, width: 60 },
    { text: 'タイトル', value: 'title', width: 200 },
    { text: 'To', value: 'sentToString', width: 100 },
    { text: '日時', value: 'createdAtNumber', width: 100 }
  ]
  messages: Array<Message> = []
  keyword = ''
  filterMode: 'excluded_test' | 'all' = 'excluded_test'

  get viewMessages(): Array<Message> {
    switch (this.filterMode) {
      case 'excluded_test': return this.filtered.filter(message => !message.test)
    }
    return this.filtered
  }

  get filtered(): Array<Message> {
    if (this.keyword) {
      return this.messages.filter(
        message => {
          return message.title.toLocaleLowerCase().includes(this.keyword.toLocaleLowerCase()) ||
            message.content.toLocaleLowerCase().includes(this.keyword.toLocaleLowerCase())
        }
      )
    }
    return this.messages
  }

  get breadcrumbs(): Array<BreadCrumb> {
    return [
      {
        text: 'メルマガ一覧'
      }
    ]
  }

  mounted(): void {
    super.mounted()
    this.reload()
  }

  async reload(): Promise<void> {
    try {
      this.loading = true
      const messages = await axios.get<Array<IMessage>>(apiV1AdminMessagesPath())
      this.messages = messages.data.map(m => new Message(m))
      this.loading = false
    } catch (e) {
      console.error(e)
    }
  }
}
